import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { getFontFamily } from '../../../utils/styleUtils';

export const StyledHeader = styled(Typography)(({ fontFamily, color, theme }) => ({
  fontFamily: getFontFamily(fontFamily, theme) || 'Raleway',
  ...(color && color.startsWith('#') ? { color: color } : {}),
}));

export const StyledParagraph = styled(Typography)(({ fontFamily, color, theme }) => ({
  fontFamily: getFontFamily(fontFamily, theme) || 'Roboto',
  ...(color && color.startsWith('#') ? { color: color } : {}),
}));
